export const TokenExpires = (error) => {
    if(error.response&&error.response.data.error==='Token is invalid'){
        sessionStorage.clear()
        localStorage.clear()
        window.location.href='/self-agentonboarding/Signin'
    }
}